const getters = {
  userInfo: (state) => state.user.userInfo,
  form: (state) => state.form.form,
};

export default getters;
